// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9db7b7a2","732":"ce0b7995","977":"ee4f8133"}[chunkId] + ".chunk.js";
};